<template>
	<FormulateInput
		:id="`products-${productKey}`"
		:key="currentValue"
		v-model="selected"
		:options="productsForForm"
		type="radio"
		:placeholder="title"
		:value="currentValue"
		@input="handleInput"
	/>
</template>

<script>
export default {
	name: 'RadioType',
	props: {
		products: {
			type: Array,
			required: true,
		},
		title: {
			type: String,
			default: 'Выберите значение',
		},
		productKey: {
			type: Number,
			default: 0,
		},
		current: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			selected: null,
		};
	},
	computed: {
		productsForForm: {
			get() {
				const products = {};

				this.products.forEach((product) => {
					products[product.id] = product.name;
				});

				return products;
			},
		},
		currentValue() {
			return this.current?.id || this.products[0].id;
		},
	},
	methods: {
		handleInput(value) {
			this.$emit('input', {
				products: value,
			});
		},
	},
};
</script>

<style scoped>

</style>
